import React from "react";
import { Navigation } from "./navigation";
import { Contact } from "./contact";

export default function BlogPage({ title, intro, sections }) {
  return (
    <>
      <Navigation />

      <article className="cc-blog-shell">
        <header className="cc-blog-hero">
          <p className="cc-blog-kicker">Crew Coin Blog</p>
          <h1>{title}</h1>
          <p className="cc-blog-intro">{intro}</p>
        </header>

        <main className="cc-blog-content">
          {sections.map((section, idx) => (
            <section key={idx} className="cc-blog-section">
              <h2>{section.heading}</h2>
              <p>{section.body}</p>
            </section>
          ))}
        </main>

        <section className="cc-blog-bottom-cta">
          <h3>Ready to motivate your team with better incentives?</h3>
          <p>Start using Crew Coin to reward consistency, boost engagement, and improve retention.</p>
          <a href="/#/signup" className="btn btn-custom2 cc-signup-btn">Get Started</a>
        </section>
      </article>

      <div className="cc-contact-spacer">
        <Contact data={{}} />
      </div>
    </>
  );
}
